import { z } from "zod";

type Mode = "create" | "update";

const agentId = z.string().trim().regex(/^\d+$/, { message: "Agent ID must contain only numbers" });
const agentName = z.string().trim().min(2, { message: "Agent name must be at least 2 characters long" });

export const getAgentAgencySchema = (mode: Mode) => {
  const agentAgencySearchSchema = z.object({
    agent: mode === "update" ? agentId : agentName,
  });

  return agentAgencySearchSchema;
};

export type AgentAgencyType = z.infer<ReturnType<typeof getAgentAgencySchema>>;
